'use strict';

var ImportCsvErrorLogController = function ImportCsvErrorLogController($scope, $rootScope) {
  var height = 24;
  var errorRowClass = 'error';
  function getRowClass(params) {
    if (!params.data.valid) {
      return errorRowClass;
    }
  }
  $scope.getErrorLogData = function () {
    return $scope.errorGridState && $scope.errorGridState.data;
  };
  $scope.gridOptions = {
    columnDefs: [{
      headerName: 'Row',
      field: 'rowId',
      width: 45
    }, {
      headerName: 'Orig',
      field: 'marketOrigin',
      width: 200
    }, {
      headerName: 'Dest',
      field: 'marketDestination',
      width: 200
    }, {
      headerName: 'Eff Date',
      field: 'begin',
      width: 200
    }, {
      headerName: 'Disc Date',
      field: 'end',
      width: 200
    }, {
      headerName: 'Class',
      field: 'fareClass',
      width: 200
    }, {
      headerName: 'Fare',
      field: 'fare',
      width: 200
    }, {
      headerName: '',
      field: 'emptyColumn',
      width: 280
    }],
    rowData: $scope.getErrorLogData(),
    rowClass: getRowClass,
    headerHeight: height,
    rowHeight: height,
    suppressRowClickSelection: true,
    suppressCellSelection: true
  };
  $scope.closeErrorLog = function () {
    $rootScope.$broadcast('configuration-market-class-fare:errorLogClose');
  };
};
ImportCsvErrorLogController.$inject = ['$scope', '$rootScope'];
module.exports = ImportCsvErrorLogController;